export default "__VITE_ASSET__DpkgBqRo__"